export default "__VITE_ASSET__Bxy1W$h9__"